import React from 'react';
export const TermsAndConditions = () => {
  return <div className="w-full" data-id="element-542">
      {/* Header */}
      <div className="bg-primary py-16 w-full" data-id="element-543">
        <div className="container mx-auto px-4" data-id="element-544">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-545">
            Terms and Conditions
          </h1>
          <p className="text-xl text-white/90" data-id="element-546">
            The terms governing your use of our website and services
          </p>
        </div>
      </div>
      {/* Content */}
      <section className="py-16 bg-light" data-id="element-547">
        <div className="container mx-auto px-4" data-id="element-548">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-549">
            <h2 className="text-2xl font-bold text-primary mb-6" data-id="element-550">
              Terms and Conditions of Service – Prismedge
            </h2>
            <div className="space-y-8" data-id="element-551">
              <div data-id="element-552">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-553">
                  1. Introduction and Acceptance of Terms
                </h3>
                <p className="text-gray-600" data-id="element-554">
                  This website (prismedge.it.com) is owned and operated by
                  Prismedge. Throughout this site, and in these Terms and
                  Conditions, the terms "we," "us," and "our" refer to
                  Prismedge. Prismedge provides this website, including all
                  content, tools, and services available from this site, to you,
                  the user, conditioned upon your acceptance of all terms,
                  conditions, policies, and notices stated herein. These Terms
                  and Conditions of Service ("Terms") govern your access to and
                  use of the Prismedge website and your purchase and use of any
                  service plans offered by us. By accessing or using any part of
                  the site, or by purchasing a service plan, you agree to be
                  bound by these Terms. If you do not agree to all the terms and
                  conditions of this Agreement, then you may not access the
                  website or use any services. These Terms constitute a legally
                  binding agreement between you and Prismedge.
                </p>
              </div>
              <div data-id="element-555">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-556">
                  2. Company Information
                </h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-557">
                  <li data-id="element-558">Business Name: Prismedge</li>
                  <li data-id="element-559">Website Address: prismedge.it.com</li>
                  <li data-id="element-560">Business Address: 78 Austhorpe Rd, Leeds LS15 8EF</li>
                  <li data-id="element-561">Customer Service Email: rawalraj2057@gmail.com</li>
                  <li data-id="element-562">Phone Number: 0800 055 4969</li>
                </ul>
              </div>
              <div data-id="element-563">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-564">
                  3. Service Plans Overview
                </h3>
                <p className="text-gray-600" data-id="element-565">
                  Prismedge specialises in providing fast, reliable appliance
                  repair and maintenance cover plans across the UK. Our service
                  plans are designed to give you peace of mind by covering the
                  repair and maintenance of specific household appliances and
                  systems that you select. Each service plan entitles customers
                  to unlimited repairs on covered appliances during the active
                  subscription period, subject to the terms, conditions, and
                  exclusions outlined herein. Full details of each available
                  plan, including specific pricing, duration of cover, what is
                  included and excluded, eligibility criteria, and any specific
                  terms applicable to particular appliances, are clearly
                  available on our product pages and during the checkout process
                  on our website. We encourage you to review these details
                  carefully before making a purchase.
                </p>
              </div>
              <div data-id="element-566">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-567">
                  4. Pricing, Payments & Order Confirmation
                </h3>
                <p className="text-gray-600 mb-3 font-medium" data-id="element-568">
                  4.1. Pricing and Currency:
                </p>
                <p className="text-gray-600 mb-4" data-id="element-569">
                  All prices displayed on our website and quoted for our service
                  plans are in GBP (£ - British Pounds Sterling), and all
                  charges will be processed exclusively in GBP.
                </p>
                <p className="text-gray-600 mb-3 font-medium" data-id="element-570">
                  4.2. Payment Methods:
                </p>
                <p className="text-gray-600 mb-4" data-id="element-571">
                  We accept secure payments via major debit and credit cards
                  (e.g., Visa, Mastercard) and Direct Debit, where applicable.
                  By providing your payment details, you confirm that you are
                  authorised to use the chosen payment method and that the
                  information provided is accurate. Payments are processed via
                  secure, third-party payment gateways.
                </p>
                <p className="text-gray-600 mb-3 font-medium" data-id="element-572">
                  4.3. Order Confirmation:
                </p>
                <p className="text-gray-600" data-id="element-573">
                  Upon successful completion of your purchase and payment, you
                  will receive an order confirmation email to the address you
                  provided. This email will serve as your proof of purchase and
                  confirmation of your service plan activation. If you do not
                  receive this confirmation within one hour of your purchase,
                  please contact rawalraj2057@gmail.com.
                </p>
              </div>
              <div data-id="element-574">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-575">
                  5. Commencement and Duration of Your Plan
                </h3>
                <p className="text-gray-600" data-id="element-576">
                  Your service plan Agreement commences on the date your
                  subscription payment is successfully processed and confirmed
                  ("Commencement Date"). The plan will remain in force for the
                  fixed duration specified at the time of your purchase (e.g.,
                  "a period of twelve (12) months," "a period of two (2) years,"
                  etc.), unless terminated earlier in accordance with the
                  provisions of this Agreement. Your service will automatically
                  expire at the end of the agreed duration, unless you choose to
                  renew it.
                </p>
              </div>
              <div data-id="element-577">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-578">
                  6. Your Right to Cancel & Refunds
                </h3>
                <p className="text-gray-600 mb-3 font-medium" data-id="element-579">
                  6.1. Cooling-Off Period:
                </p>
                <p className="text-gray-600 mb-4" data-id="element-580">
                  You have a statutory right to cancel your service plan and
                  receive a full refund within 14 calendar days from the
                  Commencement Date of your plan. This is known as the
                  "Cooling-Off Period." To exercise this right, you must clearly
                  inform us of your decision to cancel by contacting us via
                  email at rawalraj2057@gmail.com or by phone at 0800 055 4969.
                </p>
                <p className="text-gray-600 mb-3 font-medium" data-id="element-581">
                  6.2. Cancellations After Cooling-Off Period:
                </p>
                <p className="text-gray-600 mb-2" data-id="element-582">
                  <span className="font-medium" data-id="element-583">
                    Partial Refunds (Up to 28 days):
                  </span>{' '}
                  Cancellation requests made after the 14-day Cooling-Off Period
                  but within 28 calendar days from the Commencement Date may be
                  considered at our discretion. Any refunds granted during this
                  period will be assessed on a pro-rata basis, taking into
                  account the duration of coverage already provided and any
                  services rendered.
                </p>
                <p className="text-gray-600 mb-4" data-id="element-584">
                  <span className="font-medium" data-id="element-585">
                    No Refunds (After 28 days):
                  </span>{' '}
                  After 28 calendar days from the Commencement Date, refunds
                  will generally no longer be available, regardless of whether
                  services have been utilised, as the service plan coverage will
                  have been active for that period.
                </p>
                <p className="text-gray-600 mb-3 font-medium" data-id="element-586">
                  6.3. Refund Processing:
                </p>
                <p className="text-gray-600" data-id="element-587">
                  Any approved refunds will be processed and returned to your
                  original payment method. Please allow 5–10 working days for
                  the refund to appear in your account, as processing times may
                  vary depending on your bank or payment provider.
                </p>
              </div>
              <div data-id="element-588">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-589">
                  7. Exclusions from Service Plans & Prohibited Use
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-590">
                  To maintain fair use and service quality, and to clarify the
                  scope of our cover, the following are generally excluded from
                  all service plans and are considered prohibited use of our
                  services/website:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-591">
                  <li data-id="element-592">
                    Pre-existing Faults: Any faults or damage to appliances that
                    existed prior to the Commencement Date of your service plan.
                  </li>
                  <li data-id="element-593">
                    Damage from Misuse/Neglect: Faults or damage caused by
                    misuse, deliberate damage, neglect, accidents (e.g., drops,
                    spills), unauthorised repair attempts, improper
                    installation, or tampering with the appliance by you or any
                    third party not authorised by Prismedge.
                  </li>
                  <li data-id="element-594">
                    Non-Functional Repairs: Repairs or services unrelated to the
                    normal operational function of the appliance, such as purely
                    cosmetic damage (e.g., scratches, dents, discolouration).
                  </li>
                  <li data-id="element-595">
                    Non-Manufacturer Use: Appliances not used according to the
                    manufacturer's guidelines, instructions, or specifications.
                  </li>
                  <li data-id="element-596">
                    Unauthorised Modifications: Damage resulting from any
                    modifications or alterations to the appliance not approved
                    by the manufacturer.
                  </li>
                  <li data-id="element-597">
                    Consumables: Replacement of consumable items such as
                    batteries, bulbs, fuses, filters, or cleaning unless their
                    failure is a direct result of a covered breakdown.
                  </li>
                  <li data-id="element-598">
                    External Factors: Damage caused by external events beyond
                    the appliance itself, such as power surges, abnormal
                    voltage, fire, flood, lightning, pest infestation, or issues
                    with your home's electrical, water, or drainage systems
                    external to the appliance.
                  </li>
                  <li data-id="element-599">
                    Commercial Use: Appliances used for non-domestic or
                    commercial purposes, unless such usage is expressly stated
                    and agreed upon in writing by Prismedge at the time of
                    subscription.
                  </li>
                  <li data-id="element-600">
                    Illegal/Fraudulent Use: Any illegal or fraudulent use of our
                    services or website, including attempts to gain unauthorised
                    access to our systems or data.
                  </li>
                </ul>
                <p className="text-gray-600 mt-4" data-id="element-601">
                  If any of these exclusions apply, or if there is evidence of
                  prohibited use, your service plan may be cancelled by us
                  without refund or further support.
                </p>
              </div>
              <div data-id="element-602">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-603">
                  8. Your Responsibilities
                </h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-604">
                  <li data-id="element-605">
                    Accurate Information: You must provide accurate, complete,
                    and up-to-date personal, contact, and payment information
                    throughout the duration of your plan.
                  </li>
                  <li data-id="element-606">
                    Access: You are responsible for ensuring our engineers have
                    safe and reasonable access to the covered appliance(s) at
                    the agreed appointment time.
                  </li>
                  <li data-id="element-607">
                    Safe Environment: You must ensure a safe working environment
                    for our engineers at your property.
                  </li>
                  <li data-id="element-608">
                    Manufacturer Guidelines: You must use all covered equipment
                    in accordance with the manufacturer's operational guidelines
                    and instructions.
                  </li>
                </ul>
              </div>
              <div data-id="element-609">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-610">
                  9. Dispute Resolution
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-611">
                  We are committed to resolving any concerns you may have
                  regarding your service plan or charges promptly and fairly,
                  with a focus on excellent customer service.
                </p>
                <p className="text-gray-600 mb-3 font-medium" data-id="element-612">
                  Initial Contact:
                </p>
                <p className="text-gray-600 mb-4" data-id="element-613">
                  If you have an issue with your service or purchase, please
                  contact us directly in the first instance before taking any
                  further action (e.g., raising a chargeback with your bank).
                  You can reach us at:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600 mb-4" data-id="element-614">
                  <li data-id="element-615">
                    Email:{' '}
                    <a href="mailto:rawalraj2057@gmail.com" className="text-primary hover:underline" data-id="element-616">
                      rawalraj2057@gmail.com
                    </a>
                  </li>
                  <li data-id="element-617">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-primary hover:underline" data-id="element-618">
                      0800 055 4969
                    </a>
                  </li>
                </ul>
                <p className="text-gray-600 mb-4" data-id="element-619">
                  We aim to respond to all queries during business hours and
                  strive to resolve disputes quickly and fairly.
                </p>
                <p className="text-gray-600 mb-3 font-medium" data-id="element-620">Escalation:</p>
                <p className="text-gray-600" data-id="element-621">
                  If a dispute cannot be resolved directly with us, either party
                  may refer the matter to independent mediation or arbitration
                  in accordance with the provisions of the Arbitration Act 1996
                  (UK), or seek resolution through the appropriate courts of
                  England and Wales.
                </p>
              </div>
              <div data-id="element-622">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-623">
                  10. Governing Law and Jurisdiction
                </h3>
                <p className="text-gray-600" data-id="element-624">
                  This Agreement and any dispute or claim arising out of or in
                  connection with it or its subject matter or formation
                  (including non-contractual disputes or claims) shall be
                  governed by and construed in accordance with the laws of
                  England and Wales. Both parties irrevocably agree that the
                  courts of England and Wales shall have exclusive jurisdiction
                  to settle any dispute or claim arising out of or in connection
                  with this Agreement.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};